import React from "react";

import { FlatButton } from "material-ui";
import { TableRow, TableRowColumn } from "material-ui/Table";

import moment from "moment-timezone";

import InjectedSelect from "../injected-select.jsx";

import ItemBucketStore from "../../../stores/ItemBucketStore.js";
import EventStore from "../../../stores/EventStore.js";
import EventBucketStore from "../../../stores/EventBucketStore.js";
import UserStore from "../../../stores/UserStore.js";

class BoxOfficeSubitemTableAddItemColumn extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mode: null, // [null, 'ticket_bucket', 'pass_bucket', 'item_bucket']
      intermediateId: null
    };

    this.submit = this.submit.bind(this);
    this.intermediateSubmit = this.intermediateSubmit.bind(this);
  }

  submit(id) {
    if (this.state.mode === "coupon") {
      this.props.updateCurrentOrder(
        typeof id === "object" && id.code
          ? {
              coupon_code: id.code
            }
          : {
              coupon_id: id
            }
      );
      this.setState({ mode: null });
      return;
    }

    // For item bucket / ticket bucket with variant
    let variantId;
    if (
      this.state.intermediateId &&
      (this.state.mode === "item_bucket" || this.state.mode === "ticket_bucket")
    ) {
      variantId = id;
      id = this.state.intermediateId;
    }

    let subitems = this.props.orderData.subitems.slice();

    let newSubitem = {
      [this.state.mode]: id,
      quantity: 1
    };

    if (variantId) {
      newSubitem.variant = variantId;
    }

    subitems.push(newSubitem);

    this.props.updateCurrentOrder({
      subitems: subitems
    });

    // Reset for next item
    this.setState({ mode: null, intermediateId: null });
  }

  submitGiftCard() {
    this.props.updateCurrentOrder({
      subitems: this.props.orderData.subitems.concat([
        {
          name: "Gift Card",
          gift_card: true,
          variable_price: true,
          price: 0,
          giftScheduledSend: new Date(),
          quantity: 1
        }
      ])
    });

    this.setState({ mode: null, intermediateId: null });
  }

  intermediateSubmit(id) {
    if (this.state.mode === "item_bucket") {
      this.setState(
        {
          intermediateId: id
        },
        () => {
          if (id === "gift_card") {
            this.submitGiftCard();

            return;
          }
          let itemBucket = ItemBucketStore.getItemBucketById(id);
          if (itemBucket.variants.length === 1) {
            this.submit(itemBucket.variants[0].id);
          }
        }
      );
    } else if (this.state.mode === "ticket_bucket") {
      let ticketBucket = EventStore.getTicketBucketWithEventById(id);
      if (
        ticketBucket.variants.length === 0 ||
        (ticketBucket.event.venue &&
          ticketBucket.event.venue.use_reserved_seating) // variants will be chosen in seat picker
      ) {
        this.submit(id);
      } else {
        this.setState(
          {
            intermediateId: id
          },
          () => {
            // Note: we don't autosubmit for variants, because there are ALWAYS
            // at least two options, the original bucket + at least one variant.
            // if (ticketBucket.variants.length === 1) {
            //   this.submit(ticketBucket.variants[0].id);
            // }
          }
        );
      }
    }
  }

  _getTicketCount(bucket) {
    return bucket.unlimited
      ? "unlimited"
      : Math.max(bucket.quantity_remaining, 0);
  }

  _canUseTicket(bucket) {
    if (!bucket.lock_admin_only || UserStore.hasRole("admin")) return true;

    const requiredRoles =
      (bucket.lock_admin_only_role && bucket.lock_admin_only_role.split(",")) ||
      [];

    return UserStore.hasRole(requiredRoles);
  }

  getStyles() {
    return {
      column: {
        overflow: "visible"
      },
      select: {
        display: "none",
        width: 500,
        maxWidth: "80%",
        verticalAlign: "middle"
      },
      resetButton: {
        marginLeft: 7,
        verticalAlign: "middle"
      },
      addButton: {
        marginRight: 7,
        border: "1px solid",
        lineHeight: "33px"
      },
      addButtonLast: {
        marginRight: 0
      },
      intermediateLabel: {
        display: "inline-block",
        flex: 1,
        marginRight: 15
      }
    };
  }

  render() {
    const styles = this.getStyles(),
      now = new Date();

    // Box office level accounts must enter the exact discount code - no dropdown
    const requireDiscountCodeEntry = UserStore.hasRole("box_office");

    let eventBucket = EventBucketStore.getEventBucketById(
      this.props.orderData.event_bucket
    );
    let excludeOlderEvents = false;
    if (eventBucket.frontend_config.box_office_performance) {
      excludeOlderEvents = eventBucket.frontend_config.box_office_performance
        .exclude_older_events
        ? true
        : false;
    }

    return (
      <TableRowColumn colSpan={this.props.colSpan} style={styles.column}>
        <InjectedSelect
          autoFocus={this.state.mode === "ticket_bucket"}
          autosize={false}
          style={Object.assign(
            {},
            styles.select,
            this.state.mode === "ticket_bucket" &&
              !this.state.intermediateId && { display: "inline-block" }
          )}
          placeholder="Select ticket bucket"
          type="ticket_buckets"
          excludeOlder={excludeOlderEvents}
          labelToFilterString={t => `${t.event.name} - ${t.name}`}
          labelFormatter={t => {
            let count = this._getTicketCount(t);
            return (
              <div>
                <div>
                  {t.event.is_virtual &&
                  t.event.end_time &&
                  Date.now() > new Date(t.event.end_time)
                    ? "[ENDED] "
                    : count === 0
                      ? "[SOLD OUT] "
                      : ""}
                  <span style={{ fontWeight: "bold" }}>
                    {t.event.name} – {t.name}
                  </span>
                </div>
                <div>
                  {t.event.is_virtual
                    ? "Virtual Screening"
                    : t.event.venue && t.event.venue.name
                      ? t.event.venue.name
                      : "No Venue"}{" "}
                  {t.event.start_time
                    ? `– ${moment
                        .tz(t.event.start_time, t.event.timezone)
                        .format("ddd, lll")} `
                    : ""}
                  – {count} tickets remaining
                </div>
              </div>
            );
          }}
          isDisabledFunction={t =>
            this._getTicketCount(t) === 0 || !this._canUseTicket(t)
          }
          eventBucketId={this.props.orderData.event_bucket}
          sortFunction={(a, b) => {
            if (a.rawValue.event.id === b.rawValue.event.id) {
              const aIndex = a.rawValue.event.ticket_buckets.findIndex(
                  bucket => bucket.id === a.rawValue.id
                ),
                bIndex = b.rawValue.event.ticket_buckets.findIndex(
                  bucket => bucket.id === b.rawValue.id
                );
              return aIndex - bIndex;
            }

            // 20 min buffer
            let aDate = moment(a.rawValue.event.start_time).add(20, "minutes"),
              bDate = moment(b.rawValue.event.start_time).add(20, "minutes");

            if (aDate > now && now > bDate) {
              return -1;
            } else if (bDate > now && now > aDate) {
              return 1;
            }

            return aDate - bDate;
          }}
          onChange={this.intermediateSubmit}
        />
        {this.state.mode === "ticket_bucket" && this.state.intermediateId ? (
          <div
            style={Object.assign({}, styles.select, {
              display: "flex",
              display: "inline-block"
            })}
          >
            <div style={styles.intermediateLabel}>
              {
                EventStore.getTicketBucketWithEventById(
                  this.state.intermediateId
                ).event.name
              }
            </div>
            <InjectedSelect
              autoFocus={true}
              autosize={false}
              style={Object.assign(
                { verticalAlign: "middle", display: "inline-block" },
                {}
              )}
              placeholder="Select variant"
              type="ticket_bucket.variants"
              labelFormatter={p => `${p.name}`}
              eventBucketId={this.props.orderData.event_bucket}
              ticketBucketId={this.state.intermediateId}
              focus={
                this.state.mode === "ticket_bucket" &&
                this.state.intermediateId &&
                true
              }
              injectOptions={[
                {
                  label: EventStore.getTicketBucketWithEventById(
                    this.state.intermediateId
                  ).name,
                  value: null
                }
              ]}
              onChange={this.submit}
            />
          </div>
        ) : null}
        <InjectedSelect
          autoFocus={this.state.mode === "pass_bucket"}
          autosize={false}
          style={Object.assign(
            {},
            styles.select,
            this.state.mode === "pass_bucket" && { display: "inline-block" }
          )}
          placeholder="Select pass bucket"
          type="pass_buckets"
          filterBy={p => p.visible_in_box_office}
          labelToFilterString={p => `${p.name}`}
          labelFormatter={p => {
            return (
              <div>
                <div>
                  <span style={{ fontWeight: "bold" }}>{p.name}</span>
                </div>
                <div>
                  {p.unlimited
                    ? "Unlimited passes remaining"
                    : p.quantity - p.quantity_sold !== 1
                      ? `${p.quantity - p.quantity_sold} passes remaining`
                      : "1 pass remaining"}
                </div>
              </div>
            );
          }}
          isDisabledFunction={p =>
            p.unlimited ? false : p.quantity - p.quantity_sold <= 0
          }
          sortDisabledToEnd={true}
          eventBucketId={this.props.orderData.event_bucket}
          sortFunction={(a, b) =>
            a.rawValue.name.localeCompare(b.rawValue.name)
          }
          onChange={this.submit}
        />
        <InjectedSelect
          autoFocus={this.state.mode === "memberships"}
          autosize={false}
          style={Object.assign(
            {},
            styles.select,
            this.state.mode === "memberships" && { display: "inline-block" }
          )}
          placeholder="Select membership"
          type="memberships"
          filterBy={p => p.visible_in_box_office}
          labelToFilterString={p => `${p.name}`}
          labelFormatter={p => {
            return (
              <div>
                <div>
                  <span style={{ fontWeight: "bold" }}>
                    {p.name}
                  </span>
                </div>
                <div>
                  {p.unlimited
                    ? "Unlimited memberships remaining"
                    : p.quantity - p.quantity_sold !== 1
                      ? `${p.quantity - p.quantity_sold} memberships remaining`
                      : "1 membership remaining"
                  }
                </div>
              </div>
            );
          }}
          isDisabledFunction={p =>
            p.unlimited ? false : p.quantity - p.quantity_sold <= 0
          }
          sortDisabledToEnd={true}
          eventBucketId={this.props.orderData.event_bucket}
          sortFunction={(a, b) => a.rawValue.name.localeCompare(b.rawValue.name)}
          onChange={this.submit}
        />
        <InjectedSelect
          autoFocus={this.state.mode === "item_bucket"}
          autosize={false}
          style={Object.assign(
            {},
            styles.select,
            this.state.mode === "item_bucket" &&
              !this.state.intermediateId && { display: "inline-block" }
          )}
          placeholder="Select item bucket"
          type="item_buckets"
          labelFormatter={(p, disabled) =>
            `${disabled ? "[SOLD OUT] " : ""}${p.name}`
          }
          eventBucketId={this.props.orderData.event_bucket}
          isDisabledFunction={b =>
            b.variants.every(v => this._getTicketCount(v) === 0)
          }
          sortDisabledToEnd={true}
          sortFunction={(a, b) => a.label.localeCompare(b.label)}
          onChange={this.intermediateSubmit}
          injectOptions={
            eventBucket.frontend_config.gift_cards_enabled &&
            this.props.orderData.customerType === "standard"
              ? [{ label: "Gift Card", value: "gift_card" }]
              : []
          }
        />
        {this.state.mode === "item_bucket" && this.state.intermediateId ? (
          <div
            style={Object.assign({}, styles.select, {
              display: "flex",
              display: "inline-block"
            })}
          >
            <div style={styles.intermediateLabel}>
              {this.state.intermediateId === "gift_card"
                ? "Gift Card"
                : ItemBucketStore.getItemBucketById(this.state.intermediateId)
                    .name}
            </div>
            <InjectedSelect
              autoFocus={true}
              autosize={false}
              style={Object.assign(
                { verticalAlign: "middle", display: "inline-block" },
                {}
              )}
              placeholder="Select variant"
              type="item_bucket.variants"
              labelFormatter={(p, disabled) =>
                `${disabled ? "[SOLD OUT] " : ""}${p.name}`
              }
              eventBucketId={this.props.orderData.event_bucket}
              itemBucketId={this.state.intermediateId}
              sortFunction={(a, b) => a.label.localeCompare(b.label)}
              focus={
                this.state.mode === "item_bucket" &&
                this.state.intermediateId &&
                true
              }
              isDisabledFunction={v => this._getTicketCount(v) === 0}
              sortDisabledToEnd={true}
              onChange={this.submit}
            />
          </div>
        ) : null}
        <InjectedSelect
          autoFocus={this.state.mode === "coupon"}
          autosize={false}
          style={Object.assign(
            {},
            styles.select,
            this.state.mode === "coupon" && { display: "inline-block" }
          )}
          placeholder={
            requireDiscountCodeEntry
              ? "Type discount code (case-sensitive)"
              : `Select discount, ${eventBucket.frontend_config.gift_cards_enabled ? "type discount code, or type gift card code" : "or type discount code"}`
          }
          type={requireDiscountCodeEntry ? null : "coupons"}
          labelFormatter={p =>
            p.multicode
              ? `${p.name} - type code to apply discount`
              : `${p.name}`
          }
          isDisabledFunction={p => {
            if (p.multicode) {
              return true;
            } else {
              return false;
            }
          }}
          eventBucketId={this.props.orderData.event_bucket}
          sortFunction={(a, b) => a.label.localeCompare(b.label)}
          onChange={this.submit}
          creatable={true}
          creatablePromptText={s => `Use discount code "${s}"`}
          onCreateSelect={o => this.submit({ code: o.value })}
        />
        {this.state.mode ? (
          <FlatButton
            label="Back"
            onClick={() => this.setState({ mode: null, intermediateId: null })}
            style={styles.resetButton}
          />
        ) : (
          <div>
            <FlatButton
              label="+ Ticket"
              primary={true}
              onClick={() => this.setState({ mode: "ticket_bucket" })}
              style={styles.addButton}
            />
            <FlatButton
              label="+ Pass"
              primary={true}
              onClick={() => this.setState({ mode: "pass_bucket" })}
              style={styles.addButton}
            />
            {eventBucket.frontend_config.memberships_enabled && <FlatButton
              label="+ Membership"
              primary={true}
              onClick={() => this.setState({ mode: "memberships" })}
              style={styles.addButton}
            />}
            <FlatButton
              label="+ Item"
              primary={true}
              onClick={() => this.setState({ mode: "item_bucket" })}
              style={styles.addButton}
            />
            {!this.props.orderData.coupon ? (
              <FlatButton
                label={
                  eventBucket.frontend_config.gift_cards_enabled
                    ? "+ Discount / GC"
                    : "+ Discount"
                }
                primary={true}
                onClick={() => this.setState({ mode: "coupon" })}
                style={Object.assign(
                  {},
                  styles.addButton,
                  styles.addButtonLast
                )}
              />
            ) : null}
          </div>
        )}
      </TableRowColumn>
    );
  }
}

export default BoxOfficeSubitemTableAddItemColumn;



// WEBPACK FOOTER //
// ./src/app/components/partials/box-office/box-office-subitem-table-add-item-column.jsx